import styled from 'styled-components'

export const BreadcrumbsStyled = styled.nav`
  margin-bottom: ${(props) => props.theme.space.medium};
`
